import { IconButton, TableDataCell, useDialog } from "@digital-services/ui";

import TrashIcon from "@icons/trash.svg?react";
import { formatterShort } from "@utils/time-utils";

import { AzureApplicationSecretModel } from "../../models/api-secrets-models";

interface Props {
  data: AzureApplicationSecretModel;
}

export const ApiSecretDataRow = (props: Props) => {
  const { data } = props;

  const { showDialog } = useDialog();

  const onDeleteApiSecret = () => {
    showDialog({
      variant: "error",
      header: `Delete API secret created on ${formatterShort(data.createdOn)}?`,
      content: "",
      confirmButton: "Delete",
      confirmButtonVariant: "ghost",
      onConfirm: () => {
        // TBD
      },
      cancelButton: "Cancel",
      cancelButtonVariant: "discreet",
      onCancel: () => {
        /* Do nothing */
      }
    });
  };

  const expirationDate = new Date(data.createdOn);
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);

  return (
    <tr className="leading-[0px]">
      <TableDataCell>{data.description}</TableDataCell>
      <TableDataCell>{formatterShort(data.createdOn)}</TableDataCell>
      <TableDataCell>{formatterShort(expirationDate)}</TableDataCell>
      <TableDataCell>{data.secretValue}</TableDataCell>

      <TableDataCell className="py-0!">
        <IconButton onClick={onDeleteApiSecret}>
          <TrashIcon />
        </IconButton>
      </TableDataCell>
    </tr>
  );
};
